module.exports = __webpack_public_path__ + "static/media/s.ff23cab0.jpg";